import { types as t, Instance } from 'mobx-state-tree';
import Device from '~/mst/models/device';
import BitConfigType from '~/mst/common/bit_config_type';

const ThiamisModel = t
  .compose(
    Device,
    t.model({
      wifi_ssid: t.maybeNull(t.frozen()),
      wifi_password: t.maybeNull(t.frozen()),
      location: t.frozen(),
      location_description: t.frozen(),
      debug: t.maybe(BitConfigType),
      enable_battery: t.maybe(BitConfigType),
      enable_temperature: t.maybe(BitConfigType),
      enable_pressure: t.maybe(BitConfigType),
      debug_level: t.frozen(),
      debug_tags: t.frozen()
    })
  )
  .named('Thiamis');

export interface IThiamisModel extends Instance<typeof ThiamisModel> {}

export default ThiamisModel;
